import { useMediaQuery } from "@uidotdev/usehooks"
import clsx from "clsx"
import BackButton from "components/BackButton"
import PageContainer from "components/PageContainer"
import TopHeadingBar from "components/TopHeadingBar"
import { useParams } from "react-router-dom"
import { breakpoints } from "utils/createBreakpoints"

import DiscussionItem from "../DiscussionItem"

const DiscussionDetailPage = () => {
  const { id } = useParams() as { id: string }
  const xsDown = useMediaQuery(breakpoints.down("xs"))

  return (
    <div className="pb-10">
      <TopHeadingBar
        heading="Discussions"
        renderBorder
        preHeadingSlot={<BackButton className="mb-1" />}
      />

      <PageContainer className={clsx(xsDown && "px-0", "mt-2")}>
        <div className="col-span-12 grid grid-cols-12 sm:col-span-10 sm:col-start-1">
          <div className="col-span-12 col-start-1 md:col-span-10 md:col-start-2">
            <DiscussionItem discussionId={id} />
          </div>
        </div>
      </PageContainer>
    </div>
  )
}

export default DiscussionDetailPage
